import { CircularProgress } from '@mui/material';
import axios from 'axios';
import { useEffect, useState } from 'react';
import checked from '../../assets/images/checkbox_green.svg';

export function Verify() {
	const urlParams = new URLSearchParams(window.location.search);
	const i = urlParams.get('i');

	const [isVerified, setIsVerified] = useState('undefined');

	useEffect(() => {
		const loginFn = async () => {
			const accessToken = window.localStorage.getItem('access_token');
			const email = JSON.parse(window.localStorage.getItem('userdb')).email;

			// verify the discord user
			const verify = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/verify?i=${i}&access_token=${accessToken}&email=${email}`);

			// console.log("🚀 ~ loginFn ~ verify:", verify.data)
			if (verify.data) {
				setIsVerified('true');
			} else {
				setIsVerified('false');
			}
		};

		loginFn();
	});

	useEffect(() => {
		const timer = setTimeout(() => {
			window.location.href = '/'; // Replace with your target route
		}, 6000); // 6 seconds

		return () => clearTimeout(timer); // Cleanup if component unmounts
	}, []);

	return (
		<div style={{ justifySelf: 'center' }}>
			{isVerified === 'true' && (
				<div style={{ marginTop: '20vh' }} className="pl-6">
					<img style={{ margin: 'auto' }} src={checked} alt="verified checkbox" />
					<h1 style={{ margin: 'auto', textAlign: 'center' }}>Successfully verified!</h1>
					<p style={{ marginTop: '20vh', textAlign: 'center' }}>You will be redirected to WagerWiz momentarily...</p>
				</div>
			)}
			{isVerified === 'false' && <div className="pl-6">Discord user not verified</div>}
			{isVerified === 'undefined' && (
				<div className="pl-6">
					<CircularProgress />
				</div>
			)}
		</div>
	);
}
